define('SageDotCom/DataLayer/Events/CustomerSuccess/storyClickEvent',[
    'jquery',
    'SageDotCom/DataLayer/Events/eventBase'
], function ($,EventBase) {

    function StoryClickEvent(storyElement) {
        EventBase.call(this);

        var title = "";
        var container = "";
        if ($(storyElement).hasClass("customer-success-latest")) {
            title = $(storyElement).find(".score-highlight-header h4").html();
            container = "Latest Story";
        } else {
            title = $(storyElement).find(".story-headline").html();
            var parents = $(storyElement).parents();
            if (parents.hasClass("recommended-customer-story-listing")) {
                container = "Recommended Stories";
            } else if (parents.hasClass("related-customer-story-listing")) {
                container = "Related Stories";
            } else if (parents.hasClass("remaining-customer-story-listing")) {
                container = "Remaining Stories";
            } else if (parents.hasClass("customer-success-results-wrapper")) {
                container = "Story Results";
            } else if (parents.hasClass("customer-success-trending")) {
                container = "Trending Stories";
            }
        }

        this.props = {
            'event_name': 'button_click',
            'event_category': 'component',
            'event_action': 'button_click',
            'event_label': title,
            'event_name_level_1': storyElement.id,
            'event_name_level_2': $(storyElement).attr("href"),
            'event_name_level_3': storyElement.className,
            'event_name_level_4': container,
            'destination_url': $(storyElement).attr("href"),
            'element_text': title,
            'element_class': storyElement.className,
            'element_id': storyElement.id,
            'element_location': container
        };
    }

    StoryClickEvent.prototype = Object.create(EventBase.prototype);
    
    return StoryClickEvent;
});
